import formatNumber from 'number-format.js'

const MONEY_FORMAT = '### ##0,#0'
const DECIMAL_FORMAT = '### ##0,########'

export const formatSum = (number) => number?.toLocaleString('ru-RU')

export const formatNumberByMask = (number, mask) => formatNumber(mask, number)

export const formatDecimalAmount = (number) => formatNumberByMask(number, DECIMAL_FORMAT)

export const formatMoney = (number) => formatNumberByMask(number, MONEY_FORMAT)
